import React from "react";

export const AboutMeSection = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-4">
          About Me
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-12">
          {/* Text Content */}
          <div className="order-2 md:order-1">
            <div className="bg-white/70 backdrop-blur-sm rounded-3xl p-8 shadow-lg">
              <p className="text-lg text-gray-700 leading-relaxed">
                I'm an introverted human who finds comfort in art, food, and
                literature. Sometimes they help me quiet the noise, and other
                times they help me sit with my thoughts. There are days when I'm
                not sure how I'll make it through, and yet I keep finding myself
                here, showing up in small, steady ways.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mt-4">
                I see that same strength in my clients. Week after week, they
                arrive with their stories and their courage. Witnessing that
                reminds me that resilience often looks like these quiet returns
                to ourselves, even on the hard days.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-purple-200 rounded-3xl blur-2xl opacity-30 transform scale-110"></div>
              <img
                src="/assets/about-me-image.jpg"
                alt="Rasika playing ukulele"
                className="relative rounded-3xl w-full max-w-md shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
